<template>
  <div>
    <div v-if="!pasien.is_reg_heart_failure" class="text-center">
      <div
        @click="toggleHeartFailureIndicator"
        style="cursor: pointer"
        class="title mt-4"
      >
        Pasien ini belum ditandai sebagai Pasien dengan Register Heart Failure.
        <br />
        <span class="font-weight-bold">Klik di sini </span> untuk menetapkan
        sebagai Pasien Heart Failure
      </div>
    </div>
    <div v-else>
      <v-row class="pa-4">
        <v-col cols="4">
          <v-textarea
            v-model="diagnosis"
            rows="3"
            label="Diagnosa"
          ></v-textarea>
        </v-col>
        <v-col cols="3">
          <v-select
            :items="inputHOption"
            v-model="hValue"
            label="H: "
          ></v-select>
        </v-col>
        <!-- <v-col cols="4">
        <v-text-field
          label="Waktu pemeriksaan"
          v-model="examined_at"
          hide-details="auto"
        ></v-text-field>
      </v-col> -->
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="6">
          <v-expansion-panels v-model="panel">
            <div
              class="container fluid"
              @mouseover="openExpandable(0)"
              @mouseleave="closeExpandable(0)"
            >
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Pengobatan</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content
                  @mouseover="openExpandable(0)"
                  @mouseleave="closeExpandable(0)"
                >
                  <div v-for="(kategori, index) in pengobatan" :key="index">
                    <v-row v-if="index === 'otherHeart'">
                      <v-col cols="3">Obat jantung lain</v-col>
                      <v-col cols="1">
                        <v-btn
                          fab
                          color="teal"
                          x-small
                          @click="addObatHeartOther"
                          ><v-icon>mdi-plus</v-icon></v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-row v-else-if="index === 'otherNonHeart'">
                      <v-col cols="3">Obat non-jantung</v-col>
                      <v-col cols="1">
                        <v-btn fab color="teal" x-small @click="addObatNonHeart"
                          ><v-icon>mdi-plus</v-icon></v-btn
                        >
                      </v-col>
                    </v-row>
                    <v-row dense v-for="(row, idx) in kategori" :key="idx">
                      <v-col cols="1"></v-col>
                      <v-col cols="4">
                        <div v-if="index === 'common'">
                          <v-checkbox
                            :label="row.name"
                            v-model="row.value"
                            @click="checkedObatJantung(row, idx)"
                          ></v-checkbox>
                        </div>
                        <div v-else>
                          <v-text-field
                            label="Nama obat"
                            v-model="row.name"
                            hide-details="auto"
                            :ref="
                              index === 'otherHeart'
                                ? `otherHeartName`
                                : `otherNonHeartName`
                            "
                          ></v-text-field>
                        </div>
                      </v-col>
                      <v-col cols="2">
                        <v-text-field
                          label="Dosis"
                          v-model="row.dosis"
                          hide-details="auto"
                          :ref="index + 'Dosis'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          label="Sebutkan"
                          v-model="row.note"
                          hide-details="auto"
                          @keydown.tab="
                            index === 'otherHeart'
                              ? addObatHeartOther()
                              : addObatNonHeart()
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="1"
                        class="d-flex align-content-center flex-wrap"
                      >
                        <v-btn
                          fab
                          color="red"
                          x-small
                          class="float-right"
                          v-if="index !== 'common'"
                          @click="removeObat(index, idx)"
                        >
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(1)"
              @mouseleave="closeExpandable(1)"
            >
              <v-expansion-panel @change="onPanelStateChange(1)">
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Penampilan Klinis</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      cols="4"
                      v-for="(val, index) in category.penampilanKlinisKategori"
                      :key="index"
                      class="py-0"
                    >
                      <v-text-field
                        v-if="val.type === 'string'"
                        v-model="penampilanKlinis[val.index]"
                        hide-details="auto"
                        :label="val.name"
                        :ref="'field1'"
                      ></v-text-field>
                      <v-checkbox
                        v-else-if="val.type === 'boolean'"
                        :label="val.name"
                        v-model="penampilanKlinis[val.index]"
                      ></v-checkbox>
                      <v-radio-group
                        v-if="val.index === 'klin_nyha_class'"
                        v-model="penampilanKlinis.klin_nyha_class"
                        row
                        dense
                      >
                        <template v-slot:label>
                          <div>{{ val.name }}</div>
                        </template>
                        <div>
                          <v-radio
                            v-for="(val, index) in category.nyhaClassCategory"
                            :key="index"
                            :label="val.name"
                            :value="val.index"
                          ></v-radio>
                        </div>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(2)"
              @mouseleave="closeExpandable(2)"
            >
              <v-expansion-panel @change="onPanelStateChange(2)">
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Status Gizi</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      v-for="(val, index) in category.statusGiziCategory"
                      :key="index"
                      cols="4"
                    >
                      <v-text-field
                        v-model="statusGizi[val.index]"
                        :label="val.name"
                        hide-details="auto"
                        :ref="'field2'"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(3)"
              @mouseleave="closeExpandable(3)"
            >
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Optimalisasi Dosis</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      v-for="(val, index) in category.optimalisasiDosisCategory"
                      :key="index"
                      cols="4"
                    >
                      <v-checkbox
                        :label="val.name"
                        v-model="optimalisasiDosis[val.index]"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(4)"
              @mouseleave="closeExpandable(4)"
            >
              <v-expansion-panel @change="onPanelStateChange(4)">
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Ekokardiografi</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      v-for="(val, index) in category.ekokardiografiKategori"
                      :key="index"
                      cols="4"
                      class="py-0"
                    >
                      <v-text-field
                        v-if="val.type === 'string'"
                        v-model="ekokardiografi[val.index]"
                        :label="val.name"
                        hide-details="auto"
                        :ref="'field4'"
                      ></v-text-field>
                      <v-checkbox
                        v-else-if="val.type === 'boolean'"
                        :label="val.name"
                        v-model="ekokardiografi[val.index]"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(5)"
              @mouseleave="closeExpandable(5)"
            >
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><span class="text-h6">ECG</span></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      v-for="(val, index) in category.ecgKategori"
                      :key="index"
                      cols="4"
                      class="py-0"
                    >
                      <v-checkbox
                        :label="val.name"
                        v-model="ecg[val.index]"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(6)"
              @mouseleave="closeExpandable(6)"
            >
              <v-expansion-panel @change="onPanelStateChange(6)">
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Laboratorium</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <InputField2
                      v-for="(val, index) in category.laboratoriumCategory"
                      :key="index"
                      :value="laboratorium"
                      :item="val"
                      :ref="'field6'"
                    ></InputField2>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(1)"
              @mouseleave="closeExpandable(1)"
            >
              <v-expansion-panel @change="onPanelStateChange(7)">
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Cath/MSCT/Nuklir</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <InputField2
                      v-for="(val, index) in category.cathCategory"
                      :key="index"
                      :value="cath"
                      :item="val"
                      :ref="'field7'"
                    ></InputField2>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(1)"
              @mouseleave="closeExpandable(1)"
            >
              <v-expansion-panel @change="onPanelStateChange(8)">
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Fungsi Ginjal</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <InputField2
                      v-for="(val, index) in category.fungsiGinjalCategory"
                      :key="index"
                      :value="fungsiGinjal"
                      :item="val"
                      :ref="'field8'"
                    ></InputField2>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div
              class="container fluid"
              @mouseover="openExpandable(1)"
              @mouseleave="closeExpandable(1)"
            >
              <v-expansion-panel @change="onPanelStateChange(9)">
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >Keluaran (Ranap)</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <InputField2
                      v-for="(val, index) in category.ranapOutcomeCategory"
                      :key="index"
                      :value="ranapOutcome"
                      :item="val"
                      :ref="'field9'"
                    ></InputField2>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
            <div class="container fluid" v-show="showQOLField">
              <v-expansion-panel>
                <v-expansion-panel-header
                  ><span class="text-h6"
                    >QOL dan Six Minute Walk Test</span
                  ></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <div>
                    <v-row>
                      <v-col cols="7" class="text-center">
                        <span class="text-body-1 font-weight-bold">QOL</span>
                      </v-col>
                      <v-col cols="5" class="text-center font-weight-bold">
                        {{ setQolValueTitle(hValue) }}
                      </v-col>
                    </v-row>
                    <v-row
                      :style="
                        index % 2 === 0
                          ? { 'background-color': 'lightgray' }
                          : ''
                      "
                      v-for="(val, index) in category.qolCategory"
                      :key="index"
                    >
                      <v-col cols="7" class="py-0">{{ val.label }}</v-col>
                      <v-col cols="5" class="py-0 text-center">
                        <v-radio-group
                          v-model="qol[val.index]"
                          row
                          dense
                          class="mt-0"
                        >
                          <v-radio label="TB" value="tb"></v-radio>
                          <v-radio label="BS" value="bs"></v-radio>
                          <v-radio label="BB" value="bb"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="my-4 py-2">
                    <v-divider></v-divider>
                    <v-row class="mt-2">
                      <v-col cols="6" class="text-center">
                        <span class="text-body-1 font-weight-bold"
                          >Six minute Walk Test</span
                        >
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" class="pt-0">
                        <v-text-field
                          label="Six minute walk test (meter)"
                          placeholder="Isi dalam satuan meter"
                          v-model="smwt"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </div>
          </v-expansion-panels>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col cols="12">
              <div class="text-body-1 font-weight-bold">Pengobatan</div>
              <div v-for="(kategori, index) in pengobatan" :key="index">
                <div class="text-subtitle-1" v-if="index !== 'common'">
                  {{
                    index === "otherHeart"
                      ? "Obat Jantung Lain"
                      : "Obat Non Jantung"
                  }}
                </div>
                <div v-for="(item, idx) in kategori" :key="idx">
                  <v-span v-if="item.value"
                    >{{ item.name }} | {{ item.dosis }} |
                    {{ item.note }}</v-span
                  >
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-body-1 font-weight-bold">Penampilan Klinis</div>
              <div
                v-for="(item, idx) in category.penampilanKlinisKategori"
                :key="idx"
              >
                <v-span v-if="penampilanKlinis[item.index] !== null">
                  <v-span v-if="penampilanKlinis[item.index] === true"
                    ><v-icon>mdi-check</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else-if="penampilanKlinis[item.index] === false"
                    ><v-icon>mdi-close</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else
                    >{{ item.name }}: {{ penampilanKlinis[item.index] }}</v-span
                  >
                </v-span>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-body-1 font-weight-bold">Status Gizi</div>
              <div
                v-for="(item, idx) in category.statusGiziCategory"
                :key="idx"
              >
                <v-span v-if="statusGizi[item.index] !== null">
                  <v-icon v-if="statusGizi[item.index] === true"
                    >mdi-check</v-icon
                  >
                  <v-icon v-else-if="statusGizi[item.index] === false"
                    >mdi-close</v-icon
                  >
                  {{ item.name
                  }}<v-span v-if="statusGizi[item.index].length > 0"
                    >: {{ statusGizi[item.index] }}</v-span
                  >
                </v-span>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-body-1 font-weight-bold">Optimalisasi Dosis</div>
              <div
                v-for="(item, idx) in category.optimalisasiDosisCategory"
                :key="idx"
              >
                <v-span v-if="optimalisasiDosis[item.index] !== null">
                  <v-span v-if="optimalisasiDosis[item.index] === true"
                    ><v-icon>mdi-check</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else-if="optimalisasiDosis[item.index] === false"
                    ><v-icon>mdi-close</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else
                    >{{ item.name }}:
                    {{ optimalisasiDosis[item.index] }}</v-span
                  >
                </v-span>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-body-1 font-weight-bold">Ekokardiografi</div>
              <div
                v-for="(item, idx) in category.ekokardiografiKategori"
                :key="idx"
              >
                <v-span v-if="ekokardiografi[item.index] !== null">
                  <v-span v-if="ekokardiografi[item.index] === true"
                    ><v-icon>mdi-check</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else-if="ekokardiografi[item.index] === false"
                    ><v-icon>mdi-close</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else
                    >{{ item.name }}: {{ ekokardiografi[item.index] }}</v-span
                  >
                </v-span>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-body-1 font-weight-bold">ECG</div>
              <div v-for="(item, idx) in category.ecgKategori" :key="idx">
                <v-span v-if="ecg[item.index] !== null">
                  <v-span v-if="ecg[item.index] === true"
                    ><v-icon>mdi-check</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else-if="ecg[item.index] === false"
                    ><v-icon>mdi-close</v-icon> {{ item.name }}
                  </v-span>

                  <v-span v-else>{{ item.name }}: {{ ecg[item.index] }}</v-span>
                </v-span>
              </div>
            </v-col>
            <v-col cols="6">
              <InputPreview2
                :title="'Laboratorium'"
                :content="category.laboratoriumCategory"
                :value="laboratorium"
              ></InputPreview2>
            </v-col>
            <v-col cols="6">
              <InputPreview2
                :title="'Cath/MSC/Nuklir'"
                :content="category.cathCategory"
                :value="cath"
              ></InputPreview2>
            </v-col>
            <v-col cols="6">
              <InputPreview2
                :title="'Fungsi Ginjal'"
                :content="category.fungsiGinjalCategory"
                :value="fungsiGinjal"
              ></InputPreview2>
            </v-col>
            <v-col cols="6">
              <InputPreview2
                :title="'Keluaran (Ranap)'"
                :content="category.ranapOutcomeCategory"
                :value="ranapOutcome"
              ></InputPreview2>
            </v-col>
            <v-col cols="6" v-show="showQOLField">
              <div class="text-body-1 font-weight-bold">QOL</div>
              <div v-for="(item, idx) in category.qolCategory" :key="idx">
                <v-span v-if="qol[item.index] !== null">
                  {{ item.label }}: {{ qol[item.index] }}
                </v-span>
              </div>
            </v-col>
            <v-col cols="6" v-show="showQOLField">
              <div class="text-body-1 font-weight-bold">
                Six Minute Walk Test
              </div>
              <div v-if="smwt">Mampu berjalan: {{ smwt }} meter</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-6">
        <v-col cols="6">
          <v-radio-group v-model="follow_up" row class="float-right">
            <template v-slot:label>
              <div class="text-body-1">Follow Up:</div>
            </template>
            <v-radio
              v-for="(val, index) in category.followUpCategory"
              :key="index"
              :label="val.name"
              :value="val.index"
            ></v-radio> </v-radio-group
        ></v-col>
        <v-col cols="6" class="pt-6">
          <v-btn
            color="teal"
            @click="save()"
            :disabled="saving"
            :loading="saving"
          >
            <span v-if="id">Update</span>
            <span v-else>Simpan</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import http from "@/axios/http-common";
import registerHf from "@/services/registerHf";
// import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import DateFormat from "@/utility/DateFormat";
import { appModule } from "@/store/modules/app";
import { calcBmi, calcBSA } from "@/utils/rumus-kesehatan";
import { storePasien } from "@/store/modules/pasien";
// import InputField from "../reg_hf/InputField.vue";
import InputField2 from "../reg_hf/InputField2.vue";
// import InputPreview from "../reg_hf/InputPreview.vue";
import InputPreview2 from "../reg_hf/InputPreview2.vue";
import { category } from "@/types/reghf_category";

export default {
  name: "RegisterHfInputWithoutCategory",

  mounted() {
    if (this.register) {
      this.getByRegister();
    }
  },

  components: {
    // InputField,
    InputField2,
    // InputPreview,
    InputPreview2
  },

  props: {
    register: {
      type: String || Number,
      required: false
    },
    load: {
      type: Boolean,
      required: false
    },
    datareg: {
      type: Object,
      required: false,
      default: null
    }
  },

  data() {
    return {
      inputHOption: [
        { text: "H-0", value: 0 },
        { text: "H-30", value: 30 },
        { text: "H-6Bln", value: 180 },
        { text: "H-1Thn", value: 360 },
        { text: "H-2Thn", value: 720 },
        { text: "H-3Thn", value: 1080 },
        { text: "H-5Thn", value: 1800 }
      ],
      hValue: 0,
      panel: [],
      saving: false,
      id: null,
      diagnosis: null,
      pengobatan: {
        common: [
          {
            name: "Furosemide",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ACE-I",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ARB",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "Beta Blockers",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "MRA",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "Ivabradine",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "Digoksin",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ASA",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ARNI",
            value: null,
            dosis: null,
            note: null
          }
        ],
        otherHeart: [],
        otherNonHeart: []
      },
      penampilanKlinis: {
        klin_tensi: null,
        klin_nadi: null,
        klin_riw_hf: null,
        klin_riw_pci: null,
        klin_riw_op_katup: null,
        klin_hipo_perifer: null,
        klin_edema_perifer: null,
        klin_old_mi: null,
        klin_anoreksia: null,
        klin_diabetes: null,
        klin_hipertensi: null,
        klin_smoker: null,
        klin_ckd: null,
        klin_kemo: null,
        klin_nyha_class: null
      },
      statusGizi: {
        gizi_bb: null,
        gizi_tb: null,
        gizi_bsa: null,
        gizi_bmi: null,
        gizi_albumin: null
      },
      optimalisasiDosis: {
        od_acei: null,
        od_betablocker: null,
        od_mra: null
      },
      ekokardiografi: {
        eko_ef: null,
        eko_tapse: null,
        eko_mr: null,
        eko_as: null,
        eko_ph: null
      },
      ecg: {
        ecg_sinus: null,
        ecg_af: null,
        ecg_bbb: null
      },
      laboratorium: {
        hb: null,
        hmt: null,
        leukosit: null,
        asam_urat: null,
        gds: null,
        gdp: null,
        gd2jpp: null,
        na: null,
        k: null
      },
      qol: {
        qol1: null,
        qol2: null,
        qol3: null,
        qol4: null,
        qol5: null
      },
      smwt: "",
      follow_up: null,
      examined_at: new Date(),
      record: null,
      cath: {
        cad: null
      },
      fungsiGinjal: {
        ureum: null,
        bun: null,
        creatinin: null,
        gfr_mdrd: null
      },
      ranapOutcome: {
        date_in: null,
        date_out: null,
        lama_rawat: null,
        is_meninggal: null
      }
    };
  },

  methods: {
    setQolValueTitle(val) {
      return this.inputHOption.find(search => {
        return search.value === val;
      }).text;
    },
    openExpandable(val) {
      // this.panel = [val];
      console.log("open " + val);
    },
    closeExpandable() {
      // this.panel = [];
    },
    formatDate(tgl) {
      return DateFormat.formatDate(tgl);
    },
    addObatHeartOther() {
      this.pengobatan.otherHeart.push({
        name: "",
        value: true,
        dosis: null,
        note: ""
      });

      this.$nextTick(() => {
        const idxCount = this.pengobatan.otherHeart.length;

        this.$refs["otherHeartName"][idxCount - 1].focus();
      });
    },
    addObatNonHeart() {
      this.pengobatan.otherNonHeart.push({
        name: "",
        value: true,
        dosis: null,
        note: ""
      });

      const idxCount = this.pengobatan.otherNonHeart.length;

      this.$refs["otherNonHeartName"][idxCount - 1].focus();
    },
    removeObat(cat, idx) {
      console.log([cat, idx]);
      if (cat === "otherHeart") {
        this.pengobatan.otherHeart.splice(idx, 1);
      } else if (cat === "otherNonHeart") {
        this.pengobatan.otherNonHeart.splice(idx, 1);
      }
    },
    checkedObatJantung(item, idx) {
      if (item.value) {
        this.$nextTick(() => {
          this.$refs["commonDosis"][idx].focus();
        });
      } else {
        item.dosis = "";
        item.note = "";
      }
    },
    save() {
      if (!this.saving) {
        this.saving = true;

        const save = this.id
          ? registerHf.updateRegHfRecord(this.id, this.dataSend)
          : registerHf.createRegHfRecord(this.dataSend);

        const msg = this.id
          ? "Berhasil Ubah Register HF"
          : "Berhasil Simpan Register HF";

        save
          .then(response => {
            this.id = response.data.id;
            appModule.NoticeDelay(msg);

            this.$emit("successSave");
          })
          .catch(err => {
            console.log(err.response);
            if (err.response) {
              alert("error! " + err.response.status);
            }
          })
          .finally(() => {
            this.saving = false;
          });
      } else {
        alert(
          "mohon tunggu masih ada proses penyimpanan yang sedang berjalan..."
        );
      }
    },
    setExamineTime(val) {
      this.examined_at = val;
    },
    getByRegister() {
      registerHf
        .getByRegister(this.register)
        .then(response => {
          this.record = response.data;

          if (response.data) {
            this.setInput(response.data);
          }
        })
        .finally(() => {
          this.loadRecord = false;

          console.log(this.record);
        });
    },
    setInput(val) {
      this.id = val.id;
      this.pasien_rm = val.pasien_rm;
      this.register = val.register_id;
      this.hValue = val.h;
      this.diagnosis = val.diagnosis;
      this.pengobatan = val.pengobatan ?? this.pengobatan;
      this.penampilanKlinis = this.category.penampilanKlinisKategori.reduce(
        (o, key) => ({ ...o, [key.index]: val[key.index] }),
        {}
      );
      this.statusGizi = this.category.statusGiziCategory.reduce(
        (o, key) => ({ ...o, [key.index]: val[key.index] }),
        {}
      );
      this.optimalisasiDosis = this.category.optimalisasiDosisCategory.reduce(
        (o, key) => ({ ...o, [key.index]: val[key.index] }),
        {}
      );
      this.ekokardiografi = this.category.ekokardiografiKategori.reduce(
        (o, key) => ({ ...o, [key.index]: val[key.index] }),
        {}
      );
      this.ecg = this.category.ecgKategori.reduce(
        (o, key) => ({ ...o, [key.index]: val[key.index] }),
        {}
      );
      this.laboratorium = val.laboratorium ?? this.laboratorium;
      this.qol = val.qol ?? this.qol;
      this.smwt = val.smwt;
      this.follow_up = val.follow_up;
      this.examined_at = val.examined_at;
      this.cath = val.cath ?? this.cath;
      this.fungsiGinjal = val.fungsi_ginjal ?? this.fungsiGinjal;
      this.ranapOutcome = val.ranap_outcome ?? this.ranapOutcome;
    },
    clearInput() {
      this.id = null;
      this.diagnosis = null;
      this.pengobatan = {
        common: [
          {
            name: "Furosemide",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ACE-I",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ARB",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "Beta Blockers",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "MRA",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "Ivabradine",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "Digoksin",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ASA",
            value: null,
            dosis: null,
            note: null
          },
          {
            name: "ARNI",
            value: null,
            dosis: null,
            note: null
          }
        ],
        otherHeart: [],
        otherNonHeart: []
      };
      this.penampilanKlinis = {
        klin_tensi: null,
        klin_nadi: null,
        klin_riw_hf: null,
        klin_riw_pci: null,
        klin_riw_op_katup: null,
        klin_hipo_perifer: null,
        klin_edema_perifer: null,
        klin_old_mi: null,
        klin_anoreksia: null,
        klin_diabetes: null,
        klin_hipertensi: null,
        klin_smoker: null,
        klin_ckd: null,
        klin_kemo: null,
        klin_nyha_class: null
      };
      this.statusGizi = {
        gizi_bb: null,
        gizi_tb: null,
        gizi_bsa: null,
        gizi_bmi: null,
        gizi_albumin: null
      };
      this.optimalisasiDosis = {
        od_acei: null,
        od_betablocker: null,
        od_mra: null
      };
      this.ekokardiografi = {
        eko_ef: null,
        eko_tapse: null,
        eko_mr: null,
        eko_as: null,
        eko_ph: null
      };
      this.ecg = {
        ecg_sinus: null,
        ecg_af: null,
        ecg_bbb: null
      };
      this.laboratorium = {
        hb: null,
        hmt: null,
        leukosit: null,
        asam_urat: null,
        gds: null,
        gdp: null,
        gd2jpp: null,
        na: null,
        k: null
      };
      this.qol = {
        qol1: null,
        qol2: null,
        qol3: null,
        qol4: null,
        qol5: null
      };
      this.smwt = "";
      this.follow_up = null;
      this.examined_at = new Date();
      this.record = null;
      this.cath = {
        cad: null
      };
      this.fungsiGinjal = {
        ureum: null,
        bun: null,
        creatinin: null,
        gfr_mdrd: null
      };
      this.ranapOutcome = {
        date_in: null,
        date_out: null,
        lama_rawat: null,
        is_meninggal: null
      };
    },
    onPanelStateChange(val) {
      this.$nextTick(function() {
        setTimeout(() => {
          this.$refs["field" + val][0].focus();
        }, 500);
      });
    },
    calcGFR(val) {
      const gfr =
        Math.round(
          186.3 * Math.pow(val, -1.154) * Math.pow(this.umur, -0.203) * 100
        ) / 100;

      return this.pasien.jk && this.pasien.jk.substring(0, 1) === "P"
        ? (gfr * 0.742).toFixed(2)
        : gfr.toFixed(2);
    },
    convDecimal(val) {
      console.log(val);
      return val ? val.replace(/,/g, ".") : "";
    },
    toggleHeartFailureIndicator() {
      if (!this.pasien.is_reg_heart_failure) {
        const q = confirm(
          "Tandai pasien ini untuk register klinik gagal jantung?"
        );

        if (q) {
          registerHf
            .setTag(this.pasien.rm)
            .then(resp => {
              if (resp.status == 1) {
                this.pasien.is_reg_heart_failure = true;
              }
            })
            .catch(err => {
              if (err.response) {
                alert(`ERR ${err.response.status}: ${err.response.data.message}`);
              }
            });
        }
      } else {
        const q = confirm(
          "Menghapus tanda pasien ini dari register klinik gagal jantung?"
        );

        if (q) {
          registerHf
            .removeTag(this.pasien.rm)
            .then(resp => {
              if (resp.status == 1) {
                this.pasien.is_reg_heart_failure = false;
              }
            })
            .catch(err => {
              if (err.response) {
                alert(`ERR ${err.response.status}: ${err.response.data.message}`);
              }
            });
        }
      }
    }
  },

  computed: {
    dataSend() {
      const data = {
        id: this.id,
        pasien_rm: this.rm,
        register_id: this.register,
        h: this.hValue,
        diagnosis: this.diagnosis,
        pengobatan: this.pengobatan,
        ...this.penampilanKlinis,
        ...this.statusGizi,
        ...this.optimalisasiDosis,
        ...this.ekokardiografi,
        ...this.ecg,
        laboratorium: this.laboratorium,
        qol: this.qol,
        smwt: this.smwt,
        follow_up: this.follow_up,
        examined_at: this.examined_at,
        cath: this.cath,
        fungsi_ginjal: this.fungsiGinjal,
        ranap_outcome: this.ranapOutcome
      };

      return data;
    },
    showQOLField() {
      return this.hValue === 0 || this.hValue === 180 ? true : false;
    },
    rm() {
      return this.pasien.rm;
    },
    pasien() {
      return storePasien.identitasPasien;
    },
    umur() {
      const getAge = birthDate =>
        Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e10);

      const tglLahir = this.pasien.tgl_lahir,
        dob = `${tglLahir.substring(6)}-${tglLahir.substring(
          3,
          5
        )}-${tglLahir.substring(0, 2)}`;

      return getAge(dob);
    },
    los() {
      const dateIn = this.ranapOutcome.date_in,
        dateOut = this.ranapOutcome.date_out,
        diff = Math.abs(new Date(dateOut) - new Date(dateIn));

      return dateIn && dateOut
        ? Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1
        : null;
    },
    category() {
      return category;
    },
    dataProp() {
      return this.datareg;
    }
  },

  watch: {
    "statusGizi.gizi_bb": function(val) {
      this.statusGizi.gizi_bmi = calcBmi(this.statusGizi.gizi_tb, val);
      this.statusGizi.gizi_bsa = calcBSA(this.statusGizi.gizi_tb, val);
    },
    "statusGizi.gizi_tb": function(val) {
      this.statusGizi.gizi_bmi = calcBmi(val, this.statusGizi.gizi_bb);
      this.statusGizi.gizi_bsa = calcBSA(val, this.statusGizi.gizi_bb);
    },
    "fungsiGinjal.creatinin": function(val) {
      this.fungsiGinjal.gfr_mdrd = val ? this.calcGFR(val) : "";
    },
    los: function(val) {
      this.ranapOutcome.lama_rawat = val;
    },
    "ranapOutcome.is_meninggal": function(val) {
      if (val && !this.follow_up) {
        this.follow_up = 2;
      } else if (!val && this.follow_up === 2) {
        this.follow_up = null;
      }
    },
    dataProp: {
      handler(val, oldval) {
        if (val) {
          this.setInput(val);
        } else {
          this.clearInput();
        }
      },
      immediate: true
    }
  }
};
</script>
